module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"leftLabel":"Left label","rightLabel":"Right label"},"id":{"leftLabel":"Label kiri","rightLabel":"Label kanan"}}')
  delete Component.options._Ctor
}
